import axios from '@/libs/api.request'

export const login = ({userName, password}) => {
  const data = {
    userName,
    password,
    encodeType:'2'
  }
  return axios.request({
    url:'system-service/api-v1.0/SysUser/login',
    data,
    method: 'post'
  })
};

export const updatePassword = ({confirmPassword, username, oldPassword, newPassword}) => {
  const data = new URLSearchParams();
  data.append('confirmPassword', confirmPassword);
  data.append('username', username);
  data.append('oldPassword', oldPassword);
  data.append('newPassword', newPassword);
  return axios.request({
    url:'api/user/updatePassword',
    data,
    method:'post',
    headers:{'Content-Type': 'application/x-www-form-urlencoded'}
  })
};

export const userConfig = ()=>{
  return axios.request({
    url:'api/findConfig',
    method:'get'
  })
}

export const auth = ({userAccount, password, code, fastLogin}) => {
  return axios.request({
    url:'api/login',
    method:'post',
    data:{userAccount,password, code, fastLogin}
  })

}

export const getUserInfo = () => {
  return axios.request({
    url:'system-service/api-v1.0/SysUser/get_info',
    params: {
    },
    method:'get'
  })
};

export const logout = (token) => {
  const data = {
    token
  }
  return axios.request({
    url: 'api/logout',
    data,
    method: 'post'
  })
}


export const loginSys = ({auth}) => {
  return axios.request({
    url: 'control/20140901/infs/login.json',
    method: 'get',
    headers:{'Authorization':auth}
  })
}


export const checkUserIsLogin = ({account})=>{
  const params = {account}
  return axios.request({
    url:'/api/checkLogin',
    method:'get',
    params
  })
}

export const getXAndY = ({ext,type})=>{
  const data = {
    ext,
    type
  }
  return axios.request({
    url:'/api/api_v2.2.5/employee/getXAndY.json',
    method:'post',
    data
  })
}

/**
 * 存储当前用户选择的分机 左1  右2
 * @param control
 * @returns {*}
 */
export const setUserControl = ({control})=>{
  const params = new URLSearchParams()
  params.append('control', control)
  return axios.request({
    url:'/api/userConfig/control',
    method:'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data:params
  })
}



// WEBPACK FOOTER //
// ./src/api/user.js